import * as server from "Shared/server";
export function SetSelectedDelivery(date, departure, route) {
    const url = "/deliverydate/setselected/";
    const body = {
        departure: departure,
        date: date,
        route: route,
    };
    return server.postJson(url, body, null);
}
